/* Apercu au survol du panier : les 3 derniers articles ajoutes, suppression
   directe (icone poubelle) et "Voir tout (qte)". */
(function () {
  'use strict';

  var TRASH_SVG =
    '<svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15" aria-hidden="true">' +
    '<path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z" clip-rule="evenodd"/>' +
    '</svg>';

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function truncateText(str, maxLen) {
    str = str == null ? '' : String(str);
    return str.length > maxLen ? str.slice(0, maxLen) + '...' : str;
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // item.url ne porte deja nativement que ?variant=... : sans ca, revenir sur
  // la fiche produit depuis l'apercu panier perd la gravure et la quantite
  // choisies (cf. snippets/cart-item-restore-url.liquid, meme logique cote
  // panier complet/tiroir - ici en JS car construit depuis le JSON /cart.js).
  function extraQueryFromItem(item) {
    var parts = [];
    if (item.quantity > 1) parts.push('quantity=' + encodeURIComponent(item.quantity));
    var props = item.properties || {};
    Object.keys(props).forEach(function (key) {
      var val = props[key];
      if (val === null || val === '') return;
      parts.push('properties%5B' + encodeURIComponent(key) + '%5D=' + encodeURIComponent(val));
    });
    return parts.length ? '&' + parts.join('&') : '';
  }

  function updateHeaderBubble(cart) {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    var countEl = bubble.querySelector('span[aria-hidden]');
    if (countEl) countEl.textContent = cart.item_count;
    bubble.style.display = cart.item_count > 0 ? '' : 'none';
  }

  function buildPanel(cart, panel, i18n) {
    if (!cart.items.length) {
      panel.innerHTML = '<p class="tdp-cart-preview__empty">' + escapeHtml(i18n.empty) + '</p>';
      return;
    }

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var lastThree = cart.items.slice(-3).reverse();

    var html = lastThree
      .map(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') : '';
        var removeAria = i18n.removeAria.replace('{product}', item.product_title);
        return (
          '<div class="tdp-cart-preview__item">' +
            '<a class="tdp-cart-preview__item-link" href="' + escapeHtml(item.url + extraQueryFromItem(item)) + '">' +
              (img ? '<img src="' + escapeHtml(img) + '" alt="" width="50" height="50" loading="lazy">' : '') +
              '<span class="tdp-cart-preview__item-info">' +
                '<span class="tdp-cart-preview__item-title">' + escapeHtml(truncateText(item.product_title, 27)) + '</span>' +
                '<span class="tdp-cart-preview__item-meta">' +
                  item.quantity + ' × ' + formatMoney(item.price) +
                '</span>' +
              '</span>' +
            '</a>' +
            '<button type="button" class="tdp-cart-preview__item-remove" data-tdp-cart-remove data-key="' + escapeHtml(item.key) + '" aria-label="' + escapeHtml(removeAria) + '">' +
              TRASH_SVG +
            '</button>' +
          '</div>'
        );
      })
      .join('');

    if (cart.items.length > 3) {
      html +=
        '<a class="tdp-cart-preview__viewall" href="' + escapeHtml(cartUrl) + '">' +
          escapeHtml(i18n.viewAll.replace('{count}', cart.item_count)) +
        '</a>';
    }

    panel.innerHTML = html;
  }

  function initCartPreview(wrapper) {
    var panel = wrapper.querySelector('[data-tdp-cart-preview-panel]');
    if (!panel) return;

    var i18n = {
      empty: wrapper.dataset.i18nEmpty || 'Your cart is empty',
      viewAll: wrapper.dataset.i18nViewAll || 'View all ({count})',
      removeAria: wrapper.dataset.i18nRemoveAria || 'Remove {product} from cart',
    };

    // Chaque requete recoit un numero ; seule la plus recente a le droit de
    // redessiner le panneau et la bulle. Sans ca, une lecture /cart.js
    // partie juste avant une suppression (survol, focus de la poubelle au
    // clic) pouvait repondre APRES la suppression avec l'ancien panier et
    // remettre l'article et le "1" a l'ecran alors qu'il etait bien retire
    // (bug intermittent : dependait de l'ordre d'arrivee des reponses).
    var requestSeq = 0;
    var removing = 0;

    function render(cart) {
      buildPanel(cart, panel, i18n);
      updateHeaderBubble(cart);
    }

    function load() {
      if (removing) return Promise.resolve();
      var ticket = ++requestSeq;
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (ticket !== requestSeq || removing) return;
          render(cart);
        })
        .catch(function () {});
    }

    function removeItem(key, button) {
      button.disabled = true;
      removing++;
      ++requestSeq; // invalide les lectures deja en cours
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart/change ' + response.status);
          return response.json();
        })
        .then(function (cart) {
          removing--;
          ++requestSeq; // invalide les lectures lancees pendant la suppression
          // Dernier article supprime : le panneau se referme tout de suite
          // (inutile de laisser "panier vide" affiche). Son contenu n'est
          // remplace qu'une fois la fermeture finie, pour ne pas voir passer
          // le message de panier vide pendant l'animation.
          if (!cart.item_count) {
            updateHeaderBubble(cart);
            close();
            var ticket = requestSeq;
            setTimeout(function () {
              if (ticket === requestSeq && !removing) buildPanel(cart, panel, i18n);
            }, 200);
            return;
          }
          render(cart);
          // Remplacer le contenu du panneau retire l'element survole du DOM,
          // ce qui declenche parfois un mouseleave parasite sur le wrapper
          // et refermait le panneau en plein milieu de la suppression (il
          // fallait alors re-cliquer sur la poubelle). On reaffirme
          // l'ouverture si la souris est toujours reellement dessus.
          if (wrapper.matches(':hover')) open();
          // Ligne du bas supprimee : le panneau raccourcit et la souris se
          // retrouve en dehors sans que le navigateur envoie de mouseleave, le
          // panneau ne se refermait alors plus en partant. Au premier
          // mouvement, s'il n'est plus survole, il se referme normalement.
          document.addEventListener('mousemove', function checkLeft(e) {
            document.removeEventListener('mousemove', checkLeft);
            if (!wrapper.contains(e.target)) scheduleHide();
          });
        })
        .catch(function () {
          // Echec (ligne deja retiree ailleurs, reseau...) : on relit le vrai
          // panier plutot que de laisser un affichage faux.
          removing = Math.max(0, removing - 1);
          button.disabled = false;
          load();
        });
    }

    panel.addEventListener('click', function (e) {
      var button = e.target.closest('[data-tdp-cart-remove]');
      if (!button) return;
      e.preventDefault();
      cancelHide();
      removeItem(button.getAttribute('data-key'), button);
    });

    // Precharge au chargement de la page : le survol affiche alors le contenu
    // instantanement (deja pret) au lieu d'attendre une requete reseau. Le
    // survol relance quand meme un chargement en arriere-plan pour rester a
    // jour (ex. article ajoute au panier depuis un autre onglet).
    load();
    // Article ajoute (fiche, ajout rapide...) ou panier modifie ailleurs sur la
    // page : le panneau est remis a jour tout de suite, sans attendre le
    // survol. Sinon il affichait encore l'ancien contenu (ex. "panier vide")
    // pendant environ 1 s au premier survol apres l'ajout.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var cart = event && event.cartData;
        // Panier complet fourni (modification depuis le panier) : affiche
        // directement. Ajout depuis une fiche : seule la ligne ajoutee est
        // fournie, on relit le panier complet.
        if (cart && Array.isArray(cart.items) && typeof cart.item_count === 'number' && !removing) {
          ++requestSeq;
          render(cart);
        } else {
          load();
        }
      });
    }
    wrapper.addEventListener('mouseenter', load);
    wrapper.addEventListener('focusin', load);

    // Garde l'apercu ouvert ~2s apres avoir quitte le logo panier (le temps
    // de rejoindre la fenetre a la souris), et tant que la souris reste
    // dessus. Le minuteur est annule des qu'on revient sur le logo ou le
    // panneau.
    var hideTimeout = null;

    function cancelHide() {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
    }

    function open() {
      cancelHide();
      wrapper.classList.add('is-open');
    }

    // Fermeture immediate. Le focus (poubelle cliquee) est retire du panneau,
    // sinon :focus-within le garderait affiche.
    function close() {
      cancelHide();
      wrapper.classList.remove('is-open');
      if (wrapper.contains(document.activeElement)) document.activeElement.blur();
    }

    function scheduleHide() {
      cancelHide();
      hideTimeout = setTimeout(function () {
        hideTimeout = null;
        // Poubelle cliquee : elle perd le focus pendant la suppression, ce qui
        // refermait un instant le panneau alors que la souris etait toujours
        // dessus. On ne ferme que si la souris est vraiment partie.
        if (wrapper.matches(':hover')) return;
        wrapper.classList.remove('is-open');
      }, 150);
    }

    wrapper.addEventListener('mouseenter', open);
    wrapper.addEventListener('focusin', open);
    wrapper.addEventListener('mouseleave', scheduleHide);
    wrapper.addEventListener('focusout', scheduleHide);
  }

  document.querySelectorAll('[data-tdp-cart-preview]').forEach(initCartPreview);
})();
